/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCustomerNoteFromDiscriminatorValue, createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createPagedResultOfCustomerNoteFromDiscriminatorValue, serializeCreateCustomerNoteRequest, serializeCustomerNote, type CreateCustomerNoteRequest, type CustomerNote, type ErrorResponse, type InternalErrorResponse, type PagedResultOfCustomerNote } from '../../../../models/index.js';
// @ts-ignore
import { type WithCustomerNoteItemRequestBuilder, WithCustomerNoteItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/customers/{customerNumber}/notes
 */
export interface NotesRequestBuilder extends BaseRequestBuilder<NotesRequestBuilder> {
    /**
     * Gets an item from the MomentumAPI.api.customers.item.notes.item collection
     * @param customerNoteId Opaque identifier of the note to edit, as returned when the note was created.
     * @returns {WithCustomerNoteItemRequestBuilder}
     */
     byCustomerNoteId(customerNoteId: string) : WithCustomerNoteItemRequestBuilder;
    /**
     * Returns the customer's notes, newest first, a page at a time. Notes are not private to whoever wrote them: anyone who can see the customer sees every note on the timeline, and authorship only governs who may edit. Deleted notes are left out for good, and the total reflects that. Ordering is by the time the note was written, so editing a note does not move it up the timeline. A customer with no notes yet is a success with an empty page — the 404 means the customer itself is unknown.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PagedResultOfCustomerNote>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<NotesRequestBuilderGetQueryParameters> | undefined) : Promise<PagedResultOfCustomerNote | undefined>;
    /**
     * Adds a note to the customer's timeline. Notes are not private: everyone who can see the customer can read the note, and authorship governs editing rather than visibility. The authoring identity is taken from the caller's token, not from the body, and it is what later lets that caller edit the note — a note written by a caller with no user identity can never be edited afterwards. The rep number is stamped from the customer record at write time, so a note keeps the rep the customer had when it was written. Every call creates a new note: posting the same body twice leaves two notes, so retry a failed request only if you are prepared to check for a duplicate.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CustomerNote>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: CreateCustomerNoteRequest, requestConfiguration?: RequestConfiguration<NotesRequestBuilderPostQueryParameters> | undefined) : Promise<CustomerNote | undefined>;
    /**
     * Returns the customer's notes, newest first, a page at a time. Notes are not private to whoever wrote them: anyone who can see the customer sees every note on the timeline, and authorship only governs who may edit. Deleted notes are left out for good, and the total reflects that. Ordering is by the time the note was written, so editing a note does not move it up the timeline. A customer with no notes yet is a success with an empty page — the 404 means the customer itself is unknown.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<NotesRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
    /**
     * Adds a note to the customer's timeline. Notes are not private: everyone who can see the customer can read the note, and authorship governs editing rather than visibility. The authoring identity is taken from the caller's token, not from the body, and it is what later lets that caller edit the note — a note written by a caller with no user identity can never be edited afterwards. The rep number is stamped from the customer record at write time, so a note keeps the rep the customer had when it was written. Every call creates a new note: posting the same body twice leaves two notes, so retry a failed request only if you are prepared to check for a duplicate.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: CreateCustomerNoteRequest, requestConfiguration?: RequestConfiguration<NotesRequestBuilderPostQueryParameters> | undefined) : RequestInformation;
}
/**
 * Returns the customer's notes, newest first, a page at a time. Notes are not private to whoever wrote them: anyone who can see the customer sees every note on the timeline, and authorship only governs who may edit. Deleted notes are left out for good, and the total reflects that. Ordering is by the time the note was written, so editing a note does not move it up the timeline. A customer with no notes yet is a success with an empty page — the 404 means the customer itself is unknown.
 */
export interface NotesRequestBuilderGetQueryParameters {
    /**
     * Which page to return, counting from 1. Values below 1 are rejected.
     */
    pageNumber?: number;
    /**
     * How many notes per page. Values below 1 are rejected.
     */
    pageSize?: number;
    /**
     * Optional: OrganizationId to switch to (must be in the user's OrgCodes).
     */
    useOrganizationId?: string;
}
/**
 * Adds a note to the customer's timeline. Notes are not private: everyone who can see the customer can read the note, and authorship governs editing rather than visibility. The authoring identity is taken from the caller's token, not from the body, and it is what later lets that caller edit the note — a note written by a caller with no user identity can never be edited afterwards. The rep number is stamped from the customer record at write time, so a note keeps the rep the customer had when it was written. Every call creates a new note: posting the same body twice leaves two notes, so retry a failed request only if you are prepared to check for a duplicate.
 */
export interface NotesRequestBuilderPostQueryParameters {
    userId?: string;
}
/**
 * Uri template for the request builder.
 */
export const NotesRequestBuilderUriTemplate = "{+baseurl}/api/customers/{customerNumber}/notes?pageNumber={pageNumber}&pageSize={pageSize}{&useOrganizationId*,userId*}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const NotesRequestBuilderNavigationMetadata: Record<Exclude<keyof NotesRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byCustomerNoteId: {
        requestsMetadata: WithCustomerNoteItemRequestBuilderRequestsMetadata,
        pathParametersMappings: ["customerNoteId"],
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const NotesRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: NotesRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPagedResultOfCustomerNoteFromDiscriminatorValue,
    },
    post: {
        uriTemplate: NotesRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createCustomerNoteFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeCreateCustomerNoteRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
